import axios from 'axios'

import authService from './authService'
import { errorTypeService } from './errorTypeService'

export const apiService = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
  withCredentials: true,
})

async function handleErrors(error: unknown) {
  if (errorTypeService.isAuthenticationError(error)) {
    await authService.logout()
    return
  }
  // Don't handle any other error types
  return Promise.reject(error)
}

apiService.interceptors.response.use(
  // Any status code within the 2xx range will trigger this function
  (response) => response,

  // Any status codes outside the 2xx range will trigger this function
  (error) => handleErrors(error),
)
